import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Offer} from '../data/offer.model';
import {JsonConvert, OperationMode, ValueCheckingMode} from 'json2typescript';
import {AuthModel} from '../data/helper/auth.model';
import {User} from '../data/user.model';
import {Conf} from '../conf/conf.model';
import {environment} from '../../environments/environment';
import {DeeplinkModel} from '../data/deeplink.model';
import {AngularFireAuth} from '@angular/fire/auth';

@Injectable()
export class FeedService {

  public baseUrl = Conf.SM_URL;
  private USER_TIMEOUT = 20 * 60 * 1000;
  private authPath = '/wa-api/auth';
  private authPrPath = '/wa-api/auth/sua';
  private ID = ':id';
  private user: User = null;
  private deeplinkPath = '/it/wa-api/deeplinks/:id';

  constructor(
    private http: HttpClient,
    public afAuth: AngularFireAuth) {
  }

  // 'EloWHq0rV_tuCFAUHQjb8tsp9kgj6p8Wsrp5fPYYtGrR1kQLK0RS9G9busW0FJBoTioUQhjeLFQjDlEq2fRp64yf3oXgX7cwvWRDOT9dsjY48oFWqCO90NZinb8A7P2MEo65C16ASi5HjzsySnQipEe-n1b3rAbqQP9bSkyZ7VVEY-Gu-HTNcL-vzFY899bWLSlAxlWdrt9zbDOlReGnrx99K9sLxBemzhktwnlZqS0mUZgyYw_79nfY7Lv6iJOyb_cKlDHe9cLLme34EJTLJXJ0K-10HolJDjx-lX0zTYfYTT-uYjLGgaiJfeYDkK3o0RfGif8wpwGTS6rlkIIgB1HsGFCwZOKpL2U_ojmbriHEfXl3ExYyt3oIELIjhIV8SSnk9M0R0RWf8wlw6IA026c0e3iVXgR0j7dTajxmn1qYjL1zfMWrPPRKq4h-3adsivquBSGOCD8EEDTp1RM7V7bq14vErgRkaJv9YtHoxl-yHAT9XXYPcoIlQvyp6Tg-M-S9rGMSRe-jPOFC3ymDwLXI4ZS3wN20Tj7bYXdNdMABJf2NvYxOCBy7kn_PXpMd0kHoew0lP8OTOxzehAxI15Wgjail3QQJkAIWyiA7xYLB3g3AWNfQ8OJLylihtdFjglwjXhg071XJEBylhV1fmUoXAWaKuzLBZt-g9z5l0xg,j3oHSS7E6EFaOg5iLXMpSaJ6DgLtbt9o1R0-YBpR_OIkkW1qVUxCsNuwQCaA2i1_RC4XxrRnL8f0I61zR9qZUQTQJsCu9WeBSuJwG-gVKzmwnLT97WxTEpV7a_L38VFQS_Gqyt_BxTF2CN5uDsvkIz8MG1JhVjZz1ZCum677lONi3WWDfMwiZ8LFAdm1wiHvG22GnNbYkVPHO04PTGCnTMXUB331TzIFZJMUKBc-DuJM7Waujn7HcyDJCZV7XQiG5eDwjYzmPJixnir15svdeWqmeXafYuLU6d-gK5fMpv9GSIpdap9X6ygnb4CrVgaq80c3HStEIr93Yb-DQ73GMR_08lXM4_cQ4CHpgwQkmyhe--nM2TPMglvHhfJURaJb0Uc1a7PUteO34cUS-lvK40LSStw0S1_5pNg9p16vjRHztBkOy_rEyjxuxgG7TZHLEPm2cqo6R9bUGy2KwO4dxCR56vD7ob41Wci6LAf9kQ3sTQ7_QxtNz3XU2rJmoUX0TS2dPO9aI2-9yIhgV5HyM870TyvPSHv76_nfOgZcEaVmwdrqYICD7OHuVA-8R5oH2BKUyd8_KCcNxfcMktj3ANLEnZfSRdfr7wnCurHC_LRgncJwarZrwcj5fZN9Xz93wQWRfbKTm6EzMtJevPnKTSEQN94QHzTgNyDgaQiUCLw,NfCwdmk1GtfQLyCMhCkwInITu52SYYmZXkwFtwT3H8tEY0oZGXUbKDn3_42yfvREAyFcSHqGFuG5A705NZmd6lP5tRQwdzda53tdYuNm8EFrBrpAWjfNay_UB9gPweSTCn-HNobv2SDSZ6GIadH-D5o6zVgYOiMP9kN2bIbhpVvI5BTjuxlJpbZPFWJSyFau896mxVNYicFOtIEnpToWyOxTf8sbUJx98zieKHwppr88FPE2vzv6il2lqqKruWd3YYNcdp8LzArm4ubkPIEc3kCS50HgxKB4_pxq1F6-G-o7ekI0H50At58rr25GCIdr2BBkZmDRwOxdTYzFX_-xtnr8iQ-fQg7-Fc06huU2BttZiExEpBoGWOHmbtAKuWLCHvIJ4q6dFlRV8iXKudDmRlIH483lVSY2lvZ5hIQOzLg9L5q26ksWcV4FBmmmGm1DXSa2d8v9p2CEHZ3NNPD0Pu6dYIlcvtZ15SNZs-ls8h3c5iISb-f4FH7gr6oPNBPpDtbrL13QzJXj6ZZ8z1M6O90jVuWFsc0mvzPFepzFXgeRPDkxQ1AbFrzwkYGnoxHvWSLUscQ9TM72yr_L_z-mWcfRqe-9KjprId5z5Jy7ntwiCxaLMwMtW4wWllVu_0CVmzSvs7RjbcQoJYOI1hCgNqb0Ms63tqaIbG0Cy_mvdqU'
  public auth(cryptedData: string): Promise<Offer> {
    return new Promise<Offer>((resolve, reject) => {
      let httpParams = new HttpParams();
      httpParams = httpParams.append('token', cryptedData);
      httpParams = httpParams.append('resolve', 'false');
      this.http.post(this.baseUrl + this.authPath, httpParams, {headers: this.getDefHeader()}).subscribe(
        response => {
          const jsonConvert: JsonConvert = new JsonConvert();
          jsonConvert.operationMode = OperationMode.ENABLE;
          jsonConvert.ignorePrimitiveChecks = true;
          jsonConvert.valueCheckingMode = ValueCheckingMode.ALLOW_NULL;

          // firebase login
          // token:

          try {
            const auth: any = jsonConvert.deserialize(response, AuthModel);
            this.setUser(auth.user, 'app');
            this.afAuth.auth.signInWithCustomToken(auth.user.firebase_jwt);
            resolve(auth.offer);
          } catch (e) {
            console.log((<Error>e));
            reject(e);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  }

  public prAuth(token: string): Promise<AuthModel> {
    return new Promise<AuthModel>((resolve, reject) => {
      let httpParams = new HttpParams();
      httpParams = httpParams.append('token', encodeURIComponent(token));
      this.http.post(this.baseUrl + this.authPrPath, httpParams, {headers: this.getDefHeader()}).subscribe(
        response => {
          const jsonConvert: JsonConvert = new JsonConvert();
          jsonConvert.operationMode = OperationMode.ENABLE;
          jsonConvert.ignorePrimitiveChecks = true;
          jsonConvert.valueCheckingMode = ValueCheckingMode.ALLOW_NULL;
          try {
            const auth: any = jsonConvert.deserialize(response, AuthModel);
            this.setUser(auth.user, 'prauth');
            this.afAuth.auth.signInWithCustomToken(auth.user.firebase_jwt);
            resolve(auth);
          } catch (e) {
            console.log((<Error>e));
            reject(e);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  }

  public getDeeplink(id: string): Promise<DeeplinkModel> {
    return new Promise<DeeplinkModel>((resolve, reject) => {
      this.http.get(this.baseUrl + this.deeplinkPath.replace(this.ID, id)).subscribe(
        response => {
          const jsonConvert: JsonConvert = new JsonConvert();
          jsonConvert.operationMode = OperationMode.ENABLE;
          jsonConvert.ignorePrimitiveChecks = true;
          jsonConvert.valueCheckingMode = ValueCheckingMode.ALLOW_NULL;
          try {
            resolve(jsonConvert.deserializeObject(response, DeeplinkModel));
          } catch (e) {
            console.log((<Error>e));
            reject(e);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  }


  public getUser(): User {
    if (this.user != null) {
      return this.user;
    }
    const uid = localStorage.getItem('userId');
    const fullname = localStorage.getItem('userFullName');
    const sessionToken = localStorage.getItem('userSessionToken');
    const time = localStorage.getItem('userTime');
    const timestamp = parseFloat(time);
    if (new Date().getTime() < timestamp + (this.USER_TIMEOUT * (environment.production ? 1 : 100))) {
      this.user = new User(parseFloat(uid), fullname, sessionToken);
      return this.user;
    } else {
      return null;
    }
  }

  public getUserType(): string {
    return localStorage.getItem('userLogin');
  }

  public getDefHeader(): HttpHeaders {
    let httpHeader = new HttpHeaders();
    if (this.getUser() !== null) {
      httpHeader = httpHeader.append('uid', '' + this.getUser().UID);
      httpHeader = httpHeader.append('token', this.getUser().session_token);
    }
    httpHeader = httpHeader.append('application', 'x-www-form-urlencoded');
    return httpHeader;
  }

  private setUser(user: User, type: string) {
    this.user = user;
    localStorage.setItem('userId', '' + user.UID);
    localStorage.setItem('userFullName', user.fullname);
    localStorage.setItem('userSessionToken', user.session_token);
    localStorage.setItem('userTime', '' + new Date().getTime());
    localStorage.setItem('userLogin', type);
  }

}
